import { DocumentNode, QueryHookOptions, useQuery } from "@apollo/client";
import React from "react";
import { useMount } from "react-use";

type QueryComponentProps = {
  query: { query: DocumentNode; options?: QueryHookOptions };
  loader: (loading: boolean) => React.ReactElement;
  error: (error: any, refetch: () => void) => React.ReactElement;
  children: (data: any, refetch: () => void) => React.ReactElement;
  options?: { onLoadRefetch: boolean };
};

const QueryComponent = ({
  query: { query, options: queryOptions },
  options,
  loader,
  error,
  children,
}: QueryComponentProps) => {
  const {
    data,
    loading,
    error: queryError,
    refetch,
  } = useQuery(query, { ...queryOptions });

  useMount(() => {
    if (options && options.onLoadRefetch) {
      refetch();
    }
  });

  if (loading) {
    return loader(loading);
  } else if (queryError) {
    return error(queryError, refetch);
  } else {
    return children(data, refetch);
  }
};

export default QueryComponent;
